interface ChatDemoProps {
  isDark: boolean
  onDownload: () => void
}

const shaftDots = [
  { x: 11, y: 2, delay: '0.0s' },
  { x: 11, y: 4.8, delay: '0.1s' },
  { x: 11, y: 7.6, delay: '0.2s' },
  { x: 11, y: 10.4, delay: '0.3s' },
  { x: 11, y: 13.2, delay: '0.4s' },
]

const headDots = [
  { x: 11, y: 16, delay: '0.5s' },
  { x: 8.5, y: 13.5, delay: '0.4s' },
  { x: 13.5, y: 13.5, delay: '0.4s' },
  { x: 6, y: 11, delay: '0.3s' },
  { x: 16, y: 11, delay: '0.3s' },
]

export const BinaryDemo: React.FC<ChatDemoProps> = ({ isDark, onDownload }) => {
  return (
    <>
      <style>
        {`
          @keyframes premium-arrow-slide {
            0% { transform: translateY(-15px); opacity: 0; }
            15% { transform: translateY(2px); opacity: 1; }
            25% { transform: translateY(0); opacity: 1; }
            70% { transform: translateY(0); opacity: 1; }
            80% { transform: translateY(15px); opacity: 0; }
            100% { transform: translateY(15px); opacity: 0; }
          }

          @keyframes premium-base-pulse {
            0%, 12% { transform: scaleX(1); stroke-width: 2px; stroke: currentColor; }
            15% { transform: scaleX(1.3) translateY(1px); stroke-width: 2.5px; stroke: #0052FF; }
            45% { transform: scaleX(1.05) translateY(0); stroke-width: 2px; stroke: #0052FF; }
            75%, 100% { transform: scaleX(1); stroke-width: 2px; stroke: currentColor; }
          }

          @keyframes matrix-dot-pulse {
            0%, 100% { opacity: 0.4; transform: scale(0.85); }
            20% { opacity: 1; transform: scale(1.2); }
          }
        `}
      </style>

      <button
        type='button'
        onClick={onDownload}
        aria-label='Download now'
        className='group inline-flex items-center gap-2.5 bg-transparent text-left transition-transform duration-300 hover:-translate-y-0.5 sm:gap-3'
      >
        <div
          className={[
            'inline-flex h-12 w-12 items-center justify-center rounded-md border transition-colors duration-300 sm:h-14 sm:w-14',
            isDark
              ? 'border-zinc-800 bg-zinc-900 text-white group-hover:border-[#0052FF]'
              : 'border-zinc-300 bg-white text-zinc-900 group-hover:border-[#0052FF]',
          ].join(' ')}
        >
          <svg
            width='22'
            height='22'
            viewBox='0 0 24 24'
            fill='none'
            stroke='currentColor'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
            className='overflow-visible'
          >
            <g
              fill='currentColor'
              stroke='none'
              className='origin-center group-hover:[animation:premium-arrow-slide_2.5s_cubic-bezier(0.16,1,0.3,1)_infinite]'
            >
              {[...shaftDots, ...headDots].map((dot, index) => (
                <rect
                  key={`${dot.x}-${dot.y}-${index}`}
                  x={dot.x}
                  y={dot.y}
                  width='2'
                  height='2'
                  rx='0.5'
                  className='origin-center [transform-box:fill-box] [animation:matrix-dot-pulse_1.2s_infinite]'
                  style={{ animationDelay: dot.delay }}
                />
              ))}
            </g>

            <line
              x1='4'
              y1='21'
              x2='20'
              y2='21'
              className='origin-center group-hover:[animation:premium-base-pulse_2.5s_cubic-bezier(0.16,1,0.3,1)_infinite]'
            />
          </svg>
        </div>

        <div className='flex min-w-0 flex-col justify-center'>
          <span className='mono text-[15px] font-black uppercase leading-[0.95] tracking-[0.08em] text-[#1D66FF] transition-transform duration-300 group-hover:translate-x-1 sm:text-[16px] sm:tracking-[0.1em] md:text-[18px] md:tracking-[0.12em]'>
            DOWNLOAD NOW
          </span>
          <span className='mono mt-2 text-[13px] font-bold uppercase leading-none tracking-[0.08em] text-zinc-500 sm:text-[14px]'>
            [190.2 MB]
          </span>
        </div>
      </button>
    </>
  )
}
